<template>
    <div class="flex" style="flex-direction: row; align-items: center;">
        <h2>Questions</h2>
        <NewSurveyQuestionModal :key="modalKey" :style="allowEdit ? '' : 'display: none'" :surveyId="surveyID" 
            :surveyPage="activePage" :onSaveQuestion="saveQuestion" :questionTypes="questionTypes"></NewSurveyQuestionModal>
    </div>
    <div class="questionRow questionRowHeader" v-if="activePage" >
        <div class="grip" style="flex:0 0 18px"></div>
        <div style="flex: 0 0 250px; align-items: flex-start;">Description</div>
        <div style="flex: 0 0 50px; align-items: flex-start;">Req?</div>
        <div class="conditionalJson" style="flex: 0 0 200px; align-items: flex-start;">Display Conditions</div>
        <div style="flex: 0 0 200px; align-items: flex-start;">Log Activity Type</div>
        <div style="width: 30px; border-right:none;"></div>
    </div>
    <VueDraggableNext class="dragArea list-group w-full" style="padding: 0px;" :list="activePage.questions" @update="moveQuestion" :disabled="!allowEdit" v-if="activePage">
        <div class="questionRow questionRowData" v-for="(question, sqIndex) in activePage.questions" :key="sqIndex">
            <div class="grip">
                <i class="fa-solid fa-grip-vertical"></i>
            </div>
            <div class="questionTextColumn">
                <a :href="'/QuestionEdit?ID=' + question.questionInfo.id + '&return=/SurveyEdit?ID=' + surveyID ">
                    {{ getQuestionText(question.questionInfo) }}&nbsp;&nbsp; 
                <i class="fa-solid fa-arrow-up-right-from-square" style="color:#036991;"></i></a>
            </div>
            <div style="flex: 0 0 50px; align-items: flex-start;">
                <input type="checkbox" v-model="question.requiredTF" @change="saveQuestion(question, 'requiredTF')" :disabled="!allowEdit" />
            </div>
            <div class="conditionalJson" style="flex: 0 0 200px; align-items: flex-start; padding-top: 2px;">
                <i @click="showConditionalModal(question, 'question')" class="fa-pen-to-square fas fa-lg editConditions"  :style="allowEdit ? '' : 'display: none'"></i>
                <div v-html="getPrintConditions( question.conditionalJson )"></div>
            </div>
            <div style="flex: 0 0 200px; align-items: flex-start; padding-top: 2px;">
                <select v-model="question.logActivityTypeCode" style="font-size: 11px" @change="saveQuestion(question, 'logActivityTypeCode')"  :disabled="!allowEdit">
                    <option value=""></option>
                    <option v-for="logActivityType in logActivityTypes" :key="logActivityType.id" :value="logActivityType.code">{{ logActivityType.code }}</option>
                </select>
                <p v-if="question.logActivityTypeCode">{{ getTypeDescription(question.logActivityTypeCode) }}</p>
            </div>
            <div class="deleteButtonColumn">
                <div  @click="deleteQuestion (question)" :style="allowEdit ? '' : 'display: none'">
                    <i class="fas fa-lg fa-trash-can"></i>
                </div>
            </div>
        </div>
    </VueDraggableNext>
    <ConditionalExpressionModal :conditions="conditionGroup" v-if="ExpressionModalVisible" @close="ExpressionModalVisible=false" 
            :onConditionsChanged="updateConditions"></ConditionalExpressionModal>
</template>

<script>
import {data} from '../../shared/data'
import NewSurveyQuestionModal from '@/components/survey/NewSurveyQuestionModal.vue';
import { VueDraggableNext} from 'vue-draggable-next';
import ConditionalExpressionModal from '@/components/shared/ConditionalExpressions/ConditionalExpressionModal.vue';
import { printConditions } from '@/shared/logicProcessing';
import { translation } from '@/shared/translation';

export default {
    name: 'SurveyQuestionList',
    components: { NewSurveyQuestionModal, VueDraggableNext,  ConditionalExpressionModal  },
    data: function() {
        return { 
            activePage: null,
            logActivityTypes: [],
            modalKey: 0,
            questionTypes: [],
            activePageIndex: -1,
            initialLoad: true,
            ExpressionModalVisible: false,
            conditionalExpressionObject: null,
            ExpressionObjectType: '',
            conditionGroup: {}
        };
    },  
    props: {
        allowEdit: {
            type: Boolean,
            required: true
        },
        surveyID: {
            type: Number,
            required: true
        },
        surveyPage : {
            type: Object,
            default: null
        },
        onUpdate: {
            type: Function,
            default: null,
            required: true
        }
    },
    watch: {
        surveyPage: function(val) { 
            this.activePage = val;
        },
    },
    computed: {
        active() {
            if(this.inputId != null)
                return "Edit";
            else
                return "Create New";
        },
      
    },
    async mounted() {
        this.logActivityTypes = await data.getLogActivityTypes('', true);
        this.logActivityTypes.sort((a,b) => {
            if (a.typeCode > b.typeCode) return 1;
            if (a.typeCode < b.typeCode) return -1;
            return 0;
        });

        this.activePage = this.surveyPage;
    },
    methods: {
        getPrintConditions: function(conditions) {
            if(conditions != undefined && conditions != '{}' && conditions != '')
                return printConditions(JSON.parse(conditions));
            else 
                return '';
        },
        showConditionalModal: function(object, type) {
            if(type != 'calc') {
                if(object.conditionalJson == null || object.conditionalJson == undefined)
                    this.conditionGroup = {};
                else 
                    this.conditionGroup = JSON.parse(object.conditionalJson);
            }

            this.conditionalExpressionObject = object;
            this.ExpressionModalVisible = true;
            this.ExpressionObjectType = type;
        },
        updateConditions: function(conditionGroup) {
            this.conditionalExpressionObject.conditionalJson =  JSON.stringify(conditionGroup);
            this.saveQuestion(this.conditionalExpressionObject, 'conditionalJson');
        },
        moveQuestion: async function(evt) {
            if(evt) {
                var newSequence = 0;

                if(evt.newIndex == (this.activePage.questions.length - 1)) 
                    newSequence = this.activePage.questions[evt.newIndex - 1].sequence + 1;
                else if(evt.newIndex > 0)
                    newSequence = this.activePage.questions[evt.newIndex + 1].sequence;

                this.reorderQuestions(this.activePage.questions[evt.newIndex].sequence, newSequence);
            }
        },
        reorderQuestions: async function(oldSequence, newSequence) {
            var updatedQuestions = await data.reorderSurveyQuestions(this.surveyID, this.activePage.id, oldSequence, newSequence);

            var questions = [];
            for(var x = 0; x < this.activePage.questions.length; x++) { 
                var found = updatedQuestions.find(search => search.id == this.activePage.questions[x].id);
              
                if(found != null) {
                    questions.push(this.activePage.questions[x]);
                    questions[questions.length - 1].sequence = found.sequence;                        
                }
            }

            this.activePage.questions = questions;
                
            this.sortQuestions();
            this.showSuccessToaster('Saved');
        },
        sortQuestions: function() {
            this.activePage.questions.sort((a,b) => {
                return a.sequence - b.sequence;
            });
        },
        saveQuestion: async function(ques, fieldName) {
            let obj = {};
            if(fieldName) {
                obj.id = ques.id;
                obj[fieldName] = ques[fieldName];
                obj.questionId = ques.questionInfo.id;
            } else {
                obj = ques;
            }
            var result = this.processSaveResult(await data.saveSurveyQuestion(this.surveyID, this.activePage.id, obj));
            
            if(result.success) {
                this.onUpdate(ques);
            } 

            return result;
        },
        deleteQuestion: async function(ques) {
            if(confirm('Are you sure you want to delete this question?')) {
                var result = this.processDeleteResult(await data.deleteSurveyQuestion(this.surveyID, this.activePage.id, ques.id));
                if(result.success) {
                    var index = this.activePage.questions.findIndex(search => search.id == ques.id);
                    this.activePage.questions.splice(index, 1);
                }
            }
        },
        editQuestion: function(ques) {
            window.location.href = '/QuestionEdit?ID=' + ques.questionInfo.id + '&return=' + window.location.pathname + window.location.search;
        },
        saveConditionalJsonChanges: async function(jsonText, action) {
            action.conditionalJson = jsonText;
            await this.saveSurveyAction(action, 'conditionalJson');
        },
        getTypeDescription: function(logActivityTypeCode) {
            return this.logActivityTypes.find(lat => lat.code === logActivityTypeCode).description;
        },
        strip: function(html){
            let doc = new DOMParser().parseFromString(html, 'text/html');
            return doc.body.textContent || "";
        },
        getQuestionText(question) {
            const text = translation.getTranslatedText(question.defaultLanguage, question.questionTextJson);
            return this.strip(text ? text : question.description);
        }
    }
}
</script>

<style scoped>
    input, textarea {
        width: 100%;
    }

    .flex {
        display: flex;
        width: 100%;
    }

    .dragArea {
        display: flex; 
        flex-direction: row;
        padding: 5px;
        flex-wrap: wrap;
        padding-right: 40px;
    }

    :deep(.conditionalJson) {
        width: 100%;
    }

    :deep(.conditionalJson textarea) {
        width: 95%;
        min-height: 100px;
    }   

    :deep(.conditionalJson) {
        flex: 1 1 400px;
        display: flex;
        flex-direction: row; 
        align-items: center;
    }


    :deep(.conditionalJson div) {
        display: inline;
    }

    .questionRowHeader {
        font-weight: bold;
        border-bottom-style: double;
    }

    .questionRowData {
        border-bottom: solid 1px;
        padding: 10px 0px;
    }
    
    .questionRowData:nth-child(odd) {
        background-color: lightgray;

    }
    .questionRow {
        display: flex;
        flex-direction: row;
        position: relative;
        width: 100%;
        padding: 10px 0px;

        & > div {
            margin: 0px 10px 0px 0px;
            box-sizing: border-box;
            border-right: solid 1px;
            padding-right: 10px;
        }

        & > div:first-child {
            border-right: none;
        }

        .grip {
            flex: 0 0 10px;
            cursor: grab;
        }

        .editConditions { 
            display: inline;
            background-color: unset;
            border: none;
            cursor: pointer;
            color: #036991;
            line-height: unset;
            margin-right: 10px;
        }

        .deleteButtonColumn {
            width: 30px; 
            display: flex; 
            flex-direction: row; 
            align-items: center; 
            border-right: none;

            & > div {
                cursor: pointer; 
                color: darkred;
            }
        }

        .questionTextColumn {
            flex: 0 0 250px; 
            align-items: flex-start;

            & > a {
                text-decoration: none;
                color: #2c3e50;
             }

        }
    }

</style>